import { Button, Space, Tooltip, Typography } from "antd";
import { useState } from "react";
import { connect } from "react-redux";
import ModuleRenderer from "./ModuleRenderer";
import ExamPopup from "./ExamPopup";
import { getModuleExamQuestions, clearExamQuestions } from "../actions/collection";

const { Paragraph, Text } = Typography;

const CollectionModulesList = ({
    collection,
    isAuthenticated,
    mode = "purchase",
    moduleAccess,
    unlistedKey,
    urlParams,
    certificationView = false,
    getModuleExamQuestions,
    clearExamQuestions
}) => {
    const [selectedModule, setSelectedModule] = useState(
        urlParams.moduleId && parseInt(urlParams.moduleId) >= 1
            ? parseInt(urlParams.moduleId) - 1
            : null
    );
    const [showExamPopup, setShowExamPopup] = useState(false);
    const [examModule, setExamModule] = useState(null);

    const handleTakeExam = (module) => {
        getModuleExamQuestions(collection.id, module.id);
        setExamModule(module);
        setShowExamPopup(true);
    };

    const handleCloseExam = () => {
        setShowExamPopup(false);
        setExamModule(null);
        clearExamQuestions();
    };

    return (
        <div>
            <Paragraph
                className={
                    certificationView ? "certificate-view-module-title" : ""
                }>
                <Text>{collection.modules.length} Modules</Text>
            </Paragraph>
            <Space wrap={true}>
                <Button
                    className="module-list-button"
                    type={
                        selectedModule == null ||
                        selectedModule >= collection.modules.length
                            ? "primary"
                            : "default"
                    }
                    onClick={() => setSelectedModule(null)}>
                    All
                </Button>

                {collection.modules.map((module, index) => (
                    <div key={index}>
                        <Tooltip title={module.name}>
                            <Button
                                className="module-list-button"
                                type={
                                    selectedModule == index
                                        ? "primary"
                                        : "default"
                                }
                                onClick={() => setSelectedModule(index)}>
                                {index + 1}
                            </Button>
                        </Tooltip>
                    </div>
                ))}
            </Space>
            <br />
            <br />
            <ModuleRenderer
                collection={collection}
                collectionId={collection.id}
                isAuthenticated={isAuthenticated}
                mode={mode}
                modules={collection.modules}
                selectedModule={selectedModule}
                moduleAccess={moduleAccess}
                unlistedKey={unlistedKey}
                certificationView={certificationView}
                onTakeExam={handleTakeExam}
            />
            <ExamPopup
                visible={showExamPopup}
                onClose={handleCloseExam}
                collection={collection}
                module={examModule}
            />
        </div>
    );
};

export default connect(null, {
    getModuleExamQuestions,
    clearExamQuestions
})(CollectionModulesList);

